import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import React from 'react';

import { AllRegistrationScreenParams } from '../../../../utils/navigation';
import useStore from '../../../../hooks/useStore';
import { LoadingIndicator } from '../../../loadingIndicator';
import { Energimerkeversjon } from '../../../../types/energimerke';

import { useRegistrationSubmit } from './hooks/useRegistrationSubmit';
import { useAboutStateUpdate } from './hooks/useAboutStateUpdate';
import { AboutFormData } from './form/types';
import { fromUserInputToFormData } from './form/utils';
import { AboutForm } from './form';

export const RegistrationBase = () => {
  const { t } = useTranslation();
  const { isLoading, onRegistrationSubmit } = useRegistrationSubmit();
  const { registrationId } = useParams<AllRegistrationScreenParams>();
  const store = useStore();
  const { updateAboutState } = useAboutStateUpdate();

  const onAboutSubmit = (data: AboutFormData) => {
    updateAboutState(data);
    onRegistrationSubmit(data.energimerkeversjon);
  };

  const formData = fromUserInputToFormData({
    userInput: store.getState().register.userInput,
    registreringId: registrationId,
    energimerkeversjon: Energimerkeversjon.V2023
  });

  if (isLoading) {
    return <LoadingIndicator text={t('save.loading')} />;
  }

  return <AboutForm defaultValues={formData} onSubmit={onAboutSubmit} />;
};
